// extracted by mini-css-extract-plugin
module.exports = {"menuBg":"#fff","menuText":"#bfcbd9","menuActiveText":"#409eff"};